module.exports = __webpack_public_path__ + "img/magnum-club__red.b4ed4a57.svg";